<template>
    <ul class="footer__menu">
      <li class="footer__menu-item">
        <a :href="$getSubdomainLink('portal', '/contact-us')">
          Contact Us
        </a>
      </li>
      <li class="footer__menu-item">
          <a :href="$getSubdomainLink('portal', '/cancellation')">
              Cancellation & Refund Policy
          </a>
      </li>
      <li class="footer__menu-item">
        <a :href="$getSubdomainLink('portal', '/terms')">
          Terms of Use
        </a>
      </li>
      <li class="footer__menu-item">
          <a :href="$getSubdomainLink('portal', '/privacy')">
              Privacy Policy
          </a>
      </li>
    </ul>
</template>
<script>
export default {

}
</script>

